import React, { useEffect } from 'react';

import { Utils } from '@adobe/aem-react-editable-components';
import { format, parse } from 'date-fns';
import PropTypes from 'prop-types';

import { EventCard } from 'components/Event/EventCard/EventCard';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { OuterBox } from 'components/OuterBox/OuterBox';
import { Pagination } from 'components/Pagination/Pagination';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';
import { Separator } from 'components/Separator/Separator';
import { SubTitle } from 'components/SubTitle/SubTitle';

import { TENANT_ID } from 'global/constants';

import { getRelevantEventDay } from 'utils/EventDateUtils';
import { getTenantId } from 'utils/tenantUtil';

export const EventsOverview = ({
  eventData,
  loading,
  setPaginationVars,
  currentPage,
  totalPages,
  isPastEvent,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const isEditor = Utils.isInEditor();

  if (isEditor) {
    return <RenderAemComponent componentProps={{}} name="EventsOverview" />;
  }
  const renderPagination = () => {
    const lastEventDay =
      eventData &&
      eventData[eventData.length - 1] &&
      getRelevantEventDay(eventData[eventData.length - 1].eventDays);

    const lastEventDate =
      lastEventDay &&
      parse(lastEventDay.date + lastEventDay.endTime, 'yyyy-MM-ddHH:mm', new Date());

    const firstEventDay = eventData[0] && getRelevantEventDay(eventData[0].eventDays);

    const firstEventDate =
      firstEventDay &&
      parse(firstEventDay.date + firstEventDay.startTime, 'yyyy-MM-ddHH:mm', new Date());

    const eventsNumber = eventData?.length;

    return (
      <Pagination
        selectVarsForPag={setPaginationVars}
        lastItemDate={lastEventDate && format(lastEventDate, "yyyy-MM-dd'T'HH:mm:ss")}
        firstItemDate={firstEventDate && format(firstEventDate, "yyyy-MM-dd'T'HH:mm:ss")}
        totalPages={totalPages}
        itemsNumber={eventsNumber}
        currentPage={currentPage}
        text="Veranstaltungen pro Seite"
      />
    );
  };

  return (
    <>
      <OuterBox>
        {loading && <LoadingIndicator />}
        {!loading && (
          <>
            <SubTitle text="Veranstaltungen" notFramed />
            <Separator color={getTenantId() === TENANT_ID.AVA ? 'homepage' : 'secondary'} />
            <div>
              {eventData.map((data) => (
                <EventCard key={data.id} data={data} isPastEvent={isPastEvent} />
              ))}
            </div>
          </>
        )}
      </OuterBox>
      {setPaginationVars && renderPagination()}
    </>
  );
};

EventsOverview.propTypes = {
  eventData: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  setPaginationVars: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  isPastEvent: PropTypes.bool,
};

EventsOverview.defaultProps = {
  isPastEvent: false,
};
